import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-ack',
  templateUrl: './payment-ack.component.html',
  styleUrls: ['./payment-ack.component.scss']
})
export class PaymentAckComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
